import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        backgroundColor: "rgba(243, 243, 246, 1) !important", 
        color: "#808080",
        textAlign: "center",
        padding: "12px",
        position: "relative",
        left: 0,
        bottom: 0,
        width: "100%",
        fontSize: "14px",
        backdropFilter: "blur(4px)", // opsional: efek blur transparan
      }}
    >
      <p style={{padding:'0', margin:'0', fontSize:'13px'}}>&copy; {currentYear} RLA Agency, West Sumatra.</p>
      {/* <p>
        Made with ❤️ by{" "}
        <a
          href="https://yourwebsite.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#61dafb", textDecoration: "none" }}
        >
          Your Name
        </a>
      </p> */}
    </footer>
  );
}

export default Footer;